<template>
  <Loading v-if="!template" />
  <div v-else>
    <popup-duplicate-email-template ref="popupDuplicateEmailTemplate" />
    <vx-card no-shadow>
      <vs-breadcrumb class="mt-2">
        <li>
          <router-link to="/crm/email-templates"> Email templates</router-link
          ><span class="vs-breadcrum--separator">/</span>
        </li>
        <li aria-current="page" class="active">Edit e-mail template</li>
      </vs-breadcrumb>

      <div class="vx-row mb-6 mt-2">
        <div class="vx-col sm:w-2/5 w-full">
          <h2>E-mail template</h2>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Enabled</span>
        </div>
        <div class="vx-col">
          <vs-switch color="success" v-model="template.enabled" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Template name</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-input
            :content.sync="template.name"
            v-model="template.name"
            class="w-full"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Type</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-select class="w-full" v-model="template.type">
            <vs-select-item
              :key="item"
              :value="item"
              :text="item"
              v-for="item in emailTemplateTypes"
            />
          </vs-select>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Category</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-input
            :content.sync="template.category"
            v-model="template.category"
            class="w-full"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Email subject</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-input
            :content.sync="template.emailSubject"
            v-model="template.emailSubject"
            class="w-full"
          />
        </div>
      </div>

      <!--<div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Content type</span>
        </div>
        <div class="vx-col sm:w-2/5">
          <vs-select
            class="selectExample"
            label="Marketing type"
            v-model="template.consent_type"
          >
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item, index) in consentTypeOptions"
            />
          </vs-select>
        </div>
      </div>-->

      <email-template-editor
        :email-json="template.emailJson"
        ref="emailEditor"
      />

      <!-- Save & Remove Button -->
      <vs-row
        vs-justify="space-between"
        class="flex flex-wrap items-center"
        style="margin-top: 32px"
      >
        <div>
          <vs-button
            id="remove-button"
            @click="confirmRemove"
            color="danger"
            v-if="hasPermission('vp.crm.emailtemplates.edit')"
            class="mt-2"
            >Remove</vs-button
          >
          <vs-button
            id="warning-button"
            @click="$refs.popupDuplicateEmailTemplate.show()"
            v-if="hasPermission('vp.crm.emailtemplates.edit')"
            color="warning"
            class="mt-2 ml-3"
            >Duplicate</vs-button
          >
        </div>
        <vs-button
          id="save-button"
          v-if="hasPermission('vp.crm.emailtemplates.edit')"
          @click="update"
          class="mt-2"
          >Save Changes</vs-button
        >
      </vs-row>
    </vx-card>

    <vx-card no-shadow> </vx-card>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import EmailTemplateEditor from "@/components/EmailTemplateEditor/EmailTemplateEditor.vue";
import PopupDuplicateEmailTemplate from "./PopupDuplicateEmailTemplate.vue";

export default {
  components: {
    EmailTemplateEditor,
    PopupDuplicateEmailTemplate,
  },
  props: {},
  data() {
    return {
      templateId: "",
    };
  },
  methods: {
    async confirmRemove() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to delete this template?",
        accept: this.remove,
      });
    },
    async remove() {
      this.$vs.loading();
      await this.$store.dispatch("emailTemplates/delete", this.templateId);
      this.$vs.loading.close();
      this.$router.go(-1);
    },
    async update() {
      this.$vs.loading();

      try {
        const emailExport = await this.$refs.emailEditor.export();
        this.template.emailJson = JSON.stringify(emailExport.design);

        await this.$store.dispatch("emailTemplates/update", this.template);

        this.$vs.notify({
          color: "green",
          title: "Template saved",
          text: "The template was successfully saved",
        });
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Template not saved",
          text: "Template could not be saved",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  computed: {
    ...mapGetters({
      emailTemplateTypes: "emailTemplates/emailTemplateTypes",
    }),
    /*consentTypeOptions() {
      return this.consentTypes.map((e, i) => {
        return { text: e, value: i };
      });
    },*/
    template() {
      return this.$store.getters["emailTemplates/emailTemplate"](
        this.templateId
      );
    },
  },
  async created() {
    this.templateId = this.$route.params.id;
    await this.$store.dispatch("emailTemplates/getAll", true);
  },
};
</script>

<style lang="scss">
</style>